import React, { useState } from 'react';
import { Modal, Form, Button, Row, Col, InputGroup } from 'react-bootstrap';
import Currency from '../assets/images/currency.svg';
const BuyAbilityModal = ({ show, handleClose, onSubmitSuccess }) => {
  const [formData, setFormData] = useState({
    location: '',
    creditScore: '',
    annualIncome: '',
    downPayment: '',
    monthlyDebt: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form Data:', formData);
    handleClose();
    onSubmitSuccess();
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose}
      centered
      className="buy-ability-modal"
      size="lg"
    >
       <Modal.Header closeButton className="border-0">
          <Modal.Title>BuyAbility<sup>SM</sup></Modal.Title>
        </Modal.Header>
      
      <Modal.Body>
        <div className="modal-intro">
          <h4>Find homes in your budget</h4>
          <p>See a real-time view of what you can afford in today's market.</p>
        </div>

        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {/* Location */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Location <span className="required">*</span>
                </Form.Label>
                <Form.Select
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select a state</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Credit Score */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Credit score <span className="required">*</span>
                </Form.Label>
                <Form.Select
                  name="creditScore"
                  value={formData.creditScore}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">720 & above</option>
                  <option value="780+">780+</option>
                  <option value="720-779">720-779</option>
                  <option value="680-719">680-719</option>
                  <option value="640-679">640-679</option>
                  <option value="600-639">600-639</option>
                  <option value="below-600">Below 600</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {/* Annual Income */}
            <Col xs={12}>
              <Form.Group>
                <Form.Label>
                  Annual income <span className="required">*</span>
                </Form.Label>
                <InputGroup className="custom-input-group">
                  <InputGroup.Text className="icon-prefix pe-0">
                    <img src={Currency} alt="" />
                  </InputGroup.Text>
                  <Form.Control
                    type="tel"
                    name="annualIncome"
                    placeholder="Enter income"
                    value={formData.annualIncome}
                    onChange={handleInputChange}
                    required
                  />
                  <InputGroup.Text className="text-suffix ps-0">/ year</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>

            {/* Down Payment */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Down payment <span className="required">*</span>
                </Form.Label>
                <InputGroup className="custom-input-group">
                  <InputGroup.Text className="icon-prefix pe-0">
                    <img src={Currency} alt="" />
                  </InputGroup.Text>
                  <Form.Control
                    type="tel"
                    name="downPayment"
                    placeholder="Enter amount"
                    value={formData.downPayment}
                    onChange={handleInputChange}
                    required
                  />
                </InputGroup>
                <Form.Text>At least $1,500</Form.Text>
              </Form.Group>
            </Col>

            {/* Monthly Debt */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>
                  Monthly debt <span className="required">*</span>
                </Form.Label>
                <InputGroup className="custom-input-group">
                  <InputGroup.Text className="icon-prefix pe-0">
                    <img src={Currency} alt="" />
                  </InputGroup.Text>
                  <Form.Control
                    type="tel"
                    name="monthlyDebt"
                    placeholder="Enter income"
                    value={formData.monthlyDebt}
                    onChange={handleInputChange}
                    required
                  />
                  <InputGroup.Text className="text-suffix ps-0">/ year</InputGroup.Text>
                </InputGroup>
                <Form.Text>Loans, credit cards, alimony</Form.Text>
              </Form.Group>
            </Col>

            {/* Submit Button */}
            <Col xs={12}>
              <Button type="submit" className="custom-bttn w-100  style-3">
                Get your BuyAbility<sup>SM</sup>
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default BuyAbilityModal;